import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import GerberFile from 'pu-react/components/GerberFileFC';
import { processFile as processZipFile } from 'product_tabs/tab_parts/slice/process_file';
import { START_QUOTE } from '../../shared/pu-flux/QuoteActionTypes';
import { PRICE_SELECTED } from '../../shared/pu-data/QuoteSteps';

const tooltip = `For Fabrication please include in the Zip File:
- Gerber files.
- Fabrication Notes (if available)
- Fabrication Drawings (if available)

For Assembly please include in the Zip File:

- BOM
- XY Data
- Assembly Drawings (If available)
- Assembly Notes (if available)`;

const fabRequireFile = (step, destroy, lineItemId) => {
  // if (step === START_QUOTE) return true;
  //
  // if (step !== PRICE_SELECTED) return false;
  //
  // if (destroy) return false;
  //
  // if (lineItemId) return false;

  if (!destroy && lineItemId) return false;

  return true;
}

const stencilRequireFile = (stencils) => {
  if (stencils.length === 0) return false;

  const anyNew = stencils.find((stencil) => !stencil.line_item_id)

  if (anyNew) return true;

  return false;
}

const ZipFile = ({ label, text, parameters, onChangeParameter, validator }) => {
  const dispatch = useDispatch();
  
  const {
    parametersCustomer,
    quoteStep: fabricationQuoteStep,
    destroy: fabricationDestroy,
    lineItemId: fabricationLineItemId,
  } = useSelector((state) => state.fabrication)

  const {
    stencils,
  } = useSelector((state) => state.smtStencil)

  const processFile = (file) => {
    dispatch(processZipFile(file))
  }

  const requireFile = fabRequireFile(fabricationQuoteStep, fabricationDestroy, fabricationLineItemId)
    || stencilRequireFile(stencils);

  return (
    <GerberFile
      parameters={parameters}
      onChangeParameter={onChangeParameter}
      processFile={processFile}
      label={label}
      text={text}
      tooltip={tooltip}
      errorMessage={requireFile && validator.message('Zip file', parametersCustomer.filename, 'required')} />
  )
};

export default ZipFile;
